import { AsyncStorage, UserManager, WebStorageStateStore } from 'oidc-client-ts';

import { removeAuthQueryParams } from './helpers';

let userManager: UserManager;

export interface InitOptions {
  authority: string;
  clientId: string;
  store?: AsyncStorage | Storage;
}

export function initUserManager({ authority, clientId, store }: InitOptions) {
  userManager = new UserManager({
    authority,
    client_id: clientId,
    redirect_uri: removeAuthQueryParams(),
    monitorSession: true,
    userStore: store && new WebStorageStateStore({
      store,
    }),
  });

  return userManager;
}

export function getUserManager() {
  return userManager;
}
